// export const cardSize = { width: 1200, height: 800 }
export const cardSize = {
  width: 686,
  height: 460,
  x: 11,
  y: 7,
  innerWidth: 674,
  innerHeight: 440,
}
